import { styled } from '@mui/material';

import { JsonContainer } from './JsonContainer';
import { PreviewJsonProps } from './types';
import { SxProps } from '../../../types';
import { mergeSx } from '../../../utils';
import { shouldForwardProp } from '../../../utils/shouldForwardProp';
import { CodeErrorBoundary } from '../_components';
import { PreviewConfigProvider } from '../_providers';

import { tokens } from '../../../theme/generated/tokens';

const Root = styled('div', {
  name: 'DsPreviewJson',
  slot: 'Root',
  target: 'DsPreviewJson-root',
  shouldForwardProp,
  overridesResolver: (_, styles) => [styles.root],
})<{ ownerState: PreviewJsonProps }>({});

const defaultValues = {
  color: 'primary' as const,
  size: 'lg' as const,
  indentBy: 4,
  interactive: true,
  errorMessage: 'Cannot display JSON',
};

const rootDefaultStyles: SxProps = {
  borderRadius: tokens.theme.radius.sm,
};

export const PreviewJson = ({
  testId = 'json-preview',
  ...props
}: PreviewJsonProps) => {
  props = {
    ...defaultValues,
    ...props,
  };

  return (
    <PreviewConfigProvider {...props}>
      <Root
        ownerState={props}
        sx={mergeSx(rootDefaultStyles, props.rootSx)}
        data-testid={testId}
      >
        <CodeErrorBoundary>
          <JsonContainer {...props} />
        </CodeErrorBoundary>
      </Root>
    </PreviewConfigProvider>
  );
};
